module.exports = __webpack_public_path__ + "a203a22095c1d49fa3b9edda9b0a3ef2.jpg";